import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { allowedExtension } from "../constant"
import { WAPI_BASE_URL, FILE_PATH_PROFILE_IMAGE, VIEWS_MEDIBUDDY_URL } from '../constant';
export const handleFileUpload = async (newFiles, fileType = 'document') => {
  try {
    let uploadRxFiles = [];
    for (const file of newFiles) {
      const dataUrl = await readFileAsync(file);
      const fileExtension = file.name.split('.').pop();
      if (!allowedExtension.includes(fileExtension)) {
        throw new Error('File Type Not Supported Alowed File type are .jpg .jpeg .png')
      }
      const modifiedFile = new File([file], file.name.replace(/[^a-zA-Z0-9 ]/g, ''));
      const details = await startUpload(
        modifiedFile,
        'OFFLINE_CONSULT',
        fileExtension,
        fileType
      );
      if (fileType === 'profile-image') {
        return details
      }
      uploadRxFiles.push({
        fileIdentifier: details.fileIdentifier,
        fileName: details.fileName,
        url: dataUrl,
      });
    }
    return uploadRxFiles;
  }
  catch (err) {
    throw err;
  }

};

const readFileAsync = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        resolve(reader.result.toString());
      } else {
        reject(new Error('Failed to read file.'));
      }
    };
    reader.onerror = () => {
      reject(new Error('Error reading file.'));
    };
    reader.readAsDataURL(file);
  });
};


export const startUpload = async (file, module = 'OFFLINE_CONSULT', fileExtension, documentType) => {
  try {
    let filePath = '';
    let fileType = 'Report';
    let fileName = file.name;
    if (documentType === 'profile-image') {
      fileName = uuidv4() + '.' + fileExtension;
      filePath = FILE_PATH_PROFILE_IMAGE;
      fileType = 'StaticFile';
    }
    let contractType = 10401;
    const data = {
      appId: 9203,
      contractType: 10401,
      fileName: fileName,
      fileType: fileType,
      s3AccountType: 'MB',
      filePath: filePath,
    };

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${WAPI_BASE_URL}/GetFileSignedURLUpload`,
      headers: {
        authority: 'www.medibuddy.in',
        accept: 'application/json, text/plain, */*',
        'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
        booking_platform: 'DESKTOP_WEB',
        'content-type': 'application/json;charset=UTF-8',
        accesstoken: 'abc',
        platform: 'web',
      },
      data: JSON.stringify(data),
    };

    const response = await axios.request(config);
    const uploadFileResponse = await uploadFileToS3(
      response.data,
      file,
      contractType,
      filePath
    );

    if (uploadFileResponse.status == 200 && filePath) {
      const fileUrl = `${VIEWS_MEDIBUDDY_URL}/${filePath}/${fileName}`;
      return fileUrl
    }

    return uploadFileResponse.data;
  } catch (error) {
    throw new Error(error);
  }
}



const uploadFileToS3 = async (data, file, contractType, filePath) => {
  try {
    const arrayBuffer = await fileToArrayBuffer(file);
    const formData = new FormData();
    formData.append('file', file);
    var config = {
      method: 'put',
      url: data.signedURL,
      headers: {
        'Content-Type': file.type,
      },
      data: arrayBuffer,
    };

    const response = await axios.request(config);
    if (filePath) { return response; } //during filePath we dont want to save to tblDocument as /WAPI/SaveFileDetails API dont support this key
    const saveFileResponse = await saveFileDetailsInServer(
      data,
      file,
      contractType
    );
    return saveFileResponse;
  } catch (error) {
    throw new Error(error);
  }
};


function fileToArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to read file as ArrayBuffer'));
      }
    };
    reader.onerror = () => {
      reject(reader.error);
    };
    reader.readAsArrayBuffer(file);
  });
}


const saveFileDetailsInServer = async (
  data,
  file,
  contractType
) => {
  try {
    const requestBody = {
      appId: 9203,
      contractType: 10401,
      fileName: file.name,
      fileType: 'Report',
      signedURL: data.signedURL,
      fileIdentifier: data.fileIdentifier,
    };

    const config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${WAPI_BASE_URL}/SaveFileDetails`,
      headers: {
        authority: 'www.medibuddy.in',
        accept: 'application/json, text/plain, */*',
        'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
        'content-type': 'application/json;charset=UTF-8',
        pincode: 560029,
        platform: 'web',
        accesstoken: 'abc',
      },
      data: JSON.stringify(requestBody),
    };
    const response = await axios.request(config);
    return response;
  } catch (error) {
    throw new Error(error);
  }
};